// extracted by mini-css-extract-plugin
export default {"background":"MplFL","circle":"rYhIl","skeleton":"BzSqZ","filledSkeleton":"Wp8Mi","title":"dlxkc","star":"gahPL","roundStar":"cokcA","plus":"eFvMd"};